import { ref } from 'vue';
import CityRepository from '@/repositories/city/CityRepository.ts';
import {
    City,
    CitiesPaginator,
    CitiesRequestFilter, CityCreateForm, CityUpdateForm,
} from '@/types/city.type.ts';
import { PaginationMeta } from '@/types/pagination-meta.ts';
import useLoading from '@/utils/useLoading.ts';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export default function useCityRepository() {
    const arCities = ref<City[]>([]);
    const cityPaginationMeta = ref<PaginationMeta | null>(null);
    const { isLoading: isCitiesLoading, setLoading: setCitiesLoading } = useLoading();
    const cityRepository = new CityRepository();

    const getCities = (requestFilter?: CitiesRequestFilter): void => {
        setCitiesLoading(true);

        cityRepository.getCities(requestFilter)
            .then((data: CitiesPaginator) => {
                arCities.value = data.data;
                cityPaginationMeta.value = data.meta;
                setCitiesLoading(false);
            });
    };

    const getCity = (cityId: number): Promise<City> => {
        return cityRepository.getCity(cityId);
    };

    const createCity = (cityCreateForm: CityCreateForm): Promise<void> => {
        return cityRepository.createCity(cityCreateForm);
    };

    const updateCity = (id: number, cityUpdateForm: CityUpdateForm): Promise<void> => {
        return cityRepository.updateCity(id, cityUpdateForm);
    };

    const getAllCities = (): Promise<City[]> => {
        return cityRepository.getAllCities();
    };

    return {
        arCities,
        cityPaginationMeta,
        isCitiesLoading,
        getCities: getCities,
        getCity: getCity,
        createCity: createCity,
        updateCity: updateCity,
        getAllCities: getAllCities,
    };
}
